module.exports = __webpack_public_path__ + "img/img0.b987de84.jpg";